var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3367",
    "data-name": "Rectangle 3367",
    width: 24,
    height: 24,
    transform: "translate(1055 -304)",
    fill: "#343434",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0646\\u0638\\u0631\\u0633\\u0646\\u062C\\u06CC",
    transform: "translate(-1055 304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8919",
    "data-name": "Group 8919",
    transform: "translate(1058 -301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M21.333,21.333h-14v-14h10v-2h-10a2.006,2.006,0,0,0-2,2v14a2.006,2.006,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2v-8h-2Z",
    transform: "translate(-5.333 -5.333)",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__2",
    "data-name": "__TEMP__SVG__",
    d: "M12.956,13.678l-1.4,1.4,4.5,4.5,10-10-1.4-1.4-8.6,8.55Z",
    transform: "translate(-8.056 -6.578)",
    fill: "#343434",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.03d61d01b4fad3a7922b83565801c4b3.svg";
export { ForwardRef as ReactComponent };